import { styled } from 'styled-components';
import { tk } from '@sunwebgroup/ui-components';

export const RevWrapper = styled.div`
  margin-bottom: ${tk('spacing_lg')};
`;
